import { Component, Input, OnChanges, OnInit, forwardRef, ElementRef, Renderer2 } from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';
import { TagModel } from '@hub/models/tag.model';
import { SelectItem } from 'primeng/api';
import { BaseErrorForm } from '@hub/common/BaseErrorForm';


export const CUSTOM_MULTI_TAG_VALUE_ACCESSOR: any = {
	provide: NG_VALUE_ACCESSOR,
	useExisting: forwardRef(() => FormMultiSelectComponent),
	multi: true
};

@Component({
	selector: 'fm-multiselect',
	templateUrl: './form-multiselect.component.html',
	providers: [CUSTOM_MULTI_TAG_VALUE_ACCESSOR]
})
export class FormMultiSelectComponent extends BaseErrorForm implements OnInit, ControlValueAccessor, OnChanges {

	constructor(private el: ElementRef,
		private renderer: Renderer2) {
		super();
	}

	@Input() allowedTags: SelectItem[] = [];
	@Input() previoslySelectedTags: any[] = [];
	@Input() isValid: boolean;
	@Input() appendTo = 'body';
	labelText: string;
	tags: SelectItem[];
	selectedTags: TagModel[];
	deletedTags: TagModel[];

	valueDictionary: { [id: string]: any; } = {};

	selectedItems: string[] = [];

	ngOnInit() {
		this.initialize();
	}

	ngOnChanges() {
		this.InitializeTagList(this.previoslySelectedTags);
		this.InitializeTag(this.allowedTags);
	}

	initialize() {
		this.labelText = 'Select';

		this.tags = [];
		this.deletedTags = [];
		this.selectedTags = [];
		this.selectedItems = [];
		this.valueDictionary = {};

		this.InitializeTag(this.allowedTags);

		if (this.previoslySelectedTags === null) {
			this.previoslySelectedTags = [];
		} else {
			this.selectedItems = this.previoslySelectedTags;
		}

		this.InitializeTagList(this.previoslySelectedTags);
	}

	InitializeTag(allowedTags: SelectItem[]) {
		if (allowedTags !== null) {
			this.tags = [];
			for (const t of allowedTags) {
				this.tags.push({ label: t.label, value: t.value });
				this.valueDictionary[t.label] = t.value;
			}
		}
	}

	InitializeTagList(previoslySelectedTags: any[]) {
		if (previoslySelectedTags !== null) {
			// double check this
			this.deletedTags = [];
			this.selectedTags = [];
			this.selectedItems = [];
			//
			for (const t of previoslySelectedTags) {
				this.selectedItems.push(t);
				this.selectedTags.push(this.createNewTagModel(this.getLabel(t), 0, t));
			}
		}
	}

	onFocus(event: Event) {
		setTimeout(() => {
			const element: HTMLElement = this.el.nativeElement.querySelector('input.ui-inputtext');
			if (element != null) {
				element.focus();
			}
		}, 0);
	}

	ClickFunction(val: TagModel) {

		switch (val.status) {
			case 0:
				const temp = this.createNewTagModel(val.name, 2, val.id);
				this.deletedTags.push(temp);
				this.selectedTags.forEach(element => {
					if (element.id === val.id) {
						this.selectedTags = this.selectedTags.filter(l => l.id !== val.id);
						this.value = this.selectedItems.filter(l => l !== val.id);
					}
				});
				break;

			case 1:
				this.selectedTags.forEach(element => {
					if (element.id === val.id) {
						this.selectedTags = this.selectedTags.filter(l => l.id !== val.id);
						this.value = this.selectedItems.filter(l => l !== val.id);
					}
				});
				break;
			case 2:
				this.value.push(val.id);
				this.selectedTags.push(this.createNewTagModel(val.name, 0, val.id));
				this.deletedTags = this.deletedTags.filter(l => l !== val);
				break;
			default:
			// throw exception

		}

	}

	ChangeValueHandler(val: string[]) {
		
		this.selectedItems = this.selectedItems.filter((item, i, ar) => {
			return ar.indexOf(item) === i;
		});

		if (this.selectedTags.length < this.selectedItems.length) {

			this.selectedItems.forEach(element => {
				let flag: boolean = true;
				this.selectedTags.forEach(temp => {
					if (temp.id === element) {
						flag = false;
					}
				});

				if (flag) {
					let flag2: boolean = true;

					this.deletedTags.forEach(t => {
						if (t.id === element) {

							this.selectedTags.push(this.createNewTagModel(t.name, 0, t.id));
							flag2 = false;
						}
					});

					if (flag2) {
						this.selectedTags.push(this.createNewTagModel(this.getLabel(element), 1, element));
					}
				}

			});
		} else if (this.selectedTags.length > this.selectedItems.length) {

			this.selectedTags.forEach(temp => {

				let flag: boolean = true;

				this.selectedItems.forEach(element => {
					if (temp.id === element) { 
						flag = false;
					}
				});


				if (temp.status === 0) {
					const val2 = this.createNewTagModel(temp.name, 2, temp.id);
					this.deletedTags.push(val2);
				}

				if (flag) {
					this.selectedTags = this.selectedTags.filter(l => l !== temp);
				}

			});
		}

		this.selectedTags.forEach(temp1 => {
			this.deletedTags.forEach(temp2 => {
				if (temp1.id === temp2.id) {
					this.deletedTags = this.deletedTags.filter(l => l.id !== temp2.id);
				}
			});
		});

		

	}

	// functions for ngModel
	set value(val: string[]) {
		if (this.selectedItems !== val) {
			
			this.selectedItems = val;
			this.onChange(val);
		}
	}

	get value(): string[] {
		return this.selectedItems;
	}

	writeValue(val: string[]) {
		this.selectedItems = val;
		this.onChange(val);
	}

	onChange = (_) => { };
	onTouched = () => { };

	registerOnChange(fn: (_: any) => void): void { this.onChange = fn; }
	registerOnTouched(fn: () => void): void { this.onTouched = fn; }

	// helper functions
	private createNewTagModel(name: string, status: number, id: string) {
		return new TagModel(name, status, id);
	}

	private getLabel(val: any) {
		for (const temp of this.allowedTags) {
			if (val === temp.value) {
				return temp.label;
			}
		}
	}

	private getValue(label: any) {
		return this.valueDictionary[label];
	}
}
